import i18next from 'i18next';

import { allLangs } from '../all-langs';
import { fallbackLng } from '../locales-config';

// ----------------------------------------------------------------------

/**
 * 지금 언어의 숫자 표기 — 못 고르면 실행 환경 기본으로 떨어진다.
 *
 * ⚠️ **서버에서도 불린다**(`fNumber` 를 쓰는 서버 모듈이 있다). 그런데 `all-langs` 는 `'use client'` 라
 *   서버에서는 배열이 아니라 **클라이언트 참조**로 들어온다 — 그대로 `.find` 하면 던진다
 *   (`allLangs.find is not a function`). 그 예외가 부르는 쪽까지 올라가면 그 자리의 일이 통째로 실패한다.
 */
export function formatNumberLocale() {
  const lng = i18next.resolvedLanguage ?? fallbackLng;

  const table = Array.isArray(allLangs) ? allLangs : [];
  const currentLang = table.find((lang) => lang.value === lng);

  return { code: currentLang?.numberFormat.code, currency: currentLang?.numberFormat.currency };
}
